import { useController, useFormContext } from 'react-hook-form';

// Import types
import { FormFieldProps, Field } from 'types/views/form';

export const useHookFormField = ({ name, shouldUnregister = false, disabled = false, required = false }: FormFieldProps<Field>) => {
	const { control } = useFormContext();
	const { field, fieldState, formState } = useController({
		name,
		control,
		shouldUnregister,
		disabled,
		rules: { required }
	});

	return {
		field,
		fieldState,
		isError: Boolean(fieldState.error),
		isDisabled: field.disabled || formState.disabled
	};
};
